<template>
  <a-button :loading="loading" type="primary" @click="onPress">{{
    loading ? $t('saving') : $t('save.info')
  }}</a-button>
</template>

<script>
import { mapActions } from 'vuex';
import { SHOW_NOTIFICATION } from '@/store/notification/actionTypes';

export default {
  props: ['message'],
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    ...mapActions({
      showNotification: SHOW_NOTIFICATION,
    }),
    onPress() {
      this.loading = true;

      setTimeout(() => {
        this.loading = false;
        this.showNotification({
          type: 'info',
          message: this.message,
        });
      }, 1000);
    },
  },
};
</script>
